export const PRODUCT_GROUPS_QUERY_KEY = 'productGroups'
export const ARCHIVED_PRODUCT_GROUPS_QUERY_KEY = 'archivedProductGroups'
